import { Link, Stack, Typography } from '@mui/material';
import React from 'react';

type AppointmentDetailProps = {
  children?: React.ReactNode;
  StartIcon?: React.ElementType;
  text: string;
  onClick?: () => void;
};

const AppointmentDetail = ({ StartIcon, text, onClick, children }: AppointmentDetailProps) => {
  return (
    <Stack direction='row' sx={{ color: (theme) => theme.palette.grey[500] }} spacing={1} alignItems='center'>
      {StartIcon && <StartIcon fontSize='small' />}
      {Boolean(children) && children}
      <Typography variant='body2' textOverflow='ellipsis' noWrap color='text.primary'>
        {onClick ? <Link component='button' type='button' variant='body2' underline='hover' onClick={onClick}>{text}</Link> : text}
      </Typography>
    </Stack>
  );
};


export default AppointmentDetail;
